import { InputHandler } from '@maverick/hooks';
import { IsEmailValid } from '@maverick/utils';

export const GuestInfoFormValidator = (
	firstName: InputHandler<string>,
	lastName: InputHandler<string>,
	phoneNumber: InputHandler<string>,
	email: InputHandler<string>
): boolean => {
	let valid = true;

	if (!firstName?.value) {
		firstName.setError('Valid first name required');
		valid = false;
	}

	if (!lastName?.value) {
		lastName.setError('Valid last name required');
		valid = false;
	}

	if (!phoneNumber?.value || phoneNumber.value?.length !== 10) {
		phoneNumber.setError('Valid phone number required');
		valid = false;
	}

	if (!IsEmailValid(email.value)) {
		email.setError('Valid email address required');
		valid = false;
	}

	return valid;
};
